import React, { Component } from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import CheckoutLinkList from './CheckoutLinkList';
import CheckoutLinkListService from '../services/CheckoutLinkListService';

class CheckoutLinkListContainer extends Component {
  componentDidMount() {
    CheckoutLinkListService.init();
  }

  render() {
    return (
      <CheckoutLinkList
        links={toJS(CheckoutLinkListService.links)}
        fetching={CheckoutLinkListService.fetch.fetching}
        pagination={toJS(CheckoutLinkListService.pagination)}
        onDelete={CheckoutLinkListService.handleRemove}
        onChange={CheckoutLinkListService.handleChange}
      />
    );
  }
}

export default observer(CheckoutLinkListContainer);
